var React = require('react');

function MobilePhone (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 2v1.44a.446.446 0 00.4.48h3.2a.446.446 0 00.4-.48V2M6 12h4","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"clipRule":"evenodd","d":"M11.333 15H4.667C3.747 15 3 14.304 3 13.444V2.556C3 1.696 3.746 1 4.667 1h6.666C12.253 1 13 1.696 13 2.556v10.888c0 .86-.746 1.556-1.667 1.556z","stroke":"currentColor","strokeWidth":"1.944","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

MobilePhone.defaultProps = {"width":"16","height":"16","fill":"none"};

module.exports = MobilePhone;

MobilePhone.default = MobilePhone;
